import { Trash2, Layers, Eye, EyeOff } from "lucide-react";

/** Inline editor for a selected image OVERLAY clip: opacity, size, position, delete.
 *  Position x/y are the overlay's centre as a fraction of the frame (0–1); size is
 *  its width as a fraction of the frame width (height follows the image aspect). */
export default function OverlayInspector({ clip, trackId, onChange, onRemove }) {
  if (!clip) return null;
  const set = (field, v, commit = true) => onChange(trackId, clip.id, { [field]: v }, commit);
  const pct = (v) => Math.round((v ?? 0) * 100);
  return (
    <div className="flex items-center gap-3 px-3 py-2 rounded-lg bg-white/5 border border-violet-500/25 text-[11px] text-white/70">
      <Layers size={14} className="text-violet-300" />
      <span className="font-semibold text-white truncate max-w-[18%]">{clip.label || "overlay"}</span>
      <span className="font-mono text-white/40">@{(clip.start ?? 0).toFixed(2)}s · {(clip.duration ?? 0).toFixed(2)}s</span>
      <label className="flex items-center gap-1">opacity
        <input type="range" min={0} max={1} step={0.05} value={clip.opacity ?? 1}
          onChange={(e) => set("opacity", parseFloat(e.target.value))} className="w-20 accent-violet-400" />
        <span className="w-6">{pct(clip.opacity ?? 1)}</span>
      </label>
      <label className="flex items-center gap-1">size
        <input type="range" min={0.1} max={1} step={0.05} value={clip.w ?? 0.5}
          onChange={(e) => set("w", parseFloat(e.target.value))} className="w-20 accent-violet-400" />
        <span className="w-6">{pct(clip.w ?? 0.5)}</span>
      </label>
      <label className="flex items-center gap-1">x
        <input type="number" min={0} max={1} step={0.05} value={Number((clip.x ?? 0.5).toFixed(2))}
          onChange={(e) => set("x", Math.max(0, Math.min(1, parseFloat(e.target.value) || 0)))}
          className="w-12 bg-black/40 border border-white/10 rounded px-1 py-0.5" />
      </label>
      <label className="flex items-center gap-1">y
        <input type="number" min={0} max={1} step={0.05} value={Number((clip.y ?? 0.5).toFixed(2))}
          onChange={(e) => set("y", Math.max(0, Math.min(1, parseFloat(e.target.value) || 0)))}
          className="w-12 bg-black/40 border border-white/10 rounded px-1 py-0.5" />
      </label>
      <button onClick={() => set("disabled", !clip.disabled)} className={`ml-auto ${clip.disabled ? "text-white/30" : "text-white/60 hover:text-white"}`} title={clip.disabled ? "Show overlay" : "Hide / disable overlay"}>{clip.disabled ? <EyeOff size={13} /> : <Eye size={13} />}</button>
      <button onClick={() => onRemove(trackId, clip.id)} className="text-white/50 hover:text-red-400" title="Delete overlay"><Trash2 size={13} /></button>
    </div>
  );
}
